import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/cn'

/**
 * Long-form text. Constrained to a readable measure — body copy running the
 * full width of a large screen is a legibility problem, not a design choice.
 */
export function Prose({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'text-muted max-w-[65ch] space-y-4 text-base leading-relaxed',
        '[&_a]:text-brand-700 [&_a]:underline [&_a]:underline-offset-2',
        '[&_h2]:font-display [&_h2]:text-ink [&_h2]:mt-10 [&_h2]:text-2xl [&_h2]:font-semibold',
        '[&_h3]:font-display [&_h3]:text-ink [&_h3]:mt-8 [&_h3]:text-xl [&_h3]:font-semibold',
        '[&_li]:ml-5 [&_li]:list-disc',
        '[&_strong]:text-ink [&_strong]:font-semibold',
        className,
      )}
    >
      {children}
    </div>
  )
}
